<template>
    <div id="gallery" v-if="ga">
        <Waterfall :list="ga" :breakpoints="breakpoints" :gutter="0">
            <template #item="{ item, index }">
                <el-card shadow="hover" style="text-align: center;" :body-style="{ padding: '0px' }">
                    <el-image style="width: 100%" :src="item" @click="handleClick(index)" />
                </el-card>
                <i class="fa-solid fa-heart" style="font-size:1.5rem;color:#FF698C;position:absolute;right:
                                    1rem;top:1rem" v-show="item.includes('-h')" />
            </template>
        </Waterfall>
        <el-image-viewer v-if="showPreview" :url-list="ga" show-progress :initial-index="showIndex"
            @close="showPreview = false" />
    </div>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { Waterfall, LazyImg } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import service from '../utils/request.js'
import { useCache } from '../utils/usecache.js'

let route = useRoute()
const title = route.params.title[0]
const subtitle = ref()
let router = useRouter()
const current_page_name = router.currentRoute.value.name
const suffixes = ['.jpg', '.jpeg', '.png', '.gif']
const relation = ref()
const relation_list = ref()
const ga = ref()

const showPreview = ref(false)
const showIndex = ref(0)

const prop = defineProps({
    subtitle: {
        type: String,
        default: ""
    },
    charas: {
        type: Array,
        default: []
    },
    relationList: {
        type: String,
        default: []
    }
})

const breakpoints = {
    10000: { //当屏幕宽度小于等于1200
        rowPerView: 4,
    },
    700: { //当屏幕宽度小于等于500
        rowPerView: 2,
    }
}

watch(
    () => router.currentRoute.value.name,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            var new_page = '#' + newValue
            var old_page = '#' + oldValue
            $(new_page).removeClass('page-tab')
            $(new_page).addClass('page-tab-selected')
            $(old_page).removeClass('page-tab-selected')
            $(old_page).addClass('page-tab')
        }
    }
)

const getRelation = (title) => {
    var api = '/user/relation/list'
    service.get(api).then(res => {
        relation_list.value = res.data.find(relation => relation.title === title);
        // function isNotEmpty(value) {
        //     return value !== undefined && value !== null && value !== "";
        // }
        relation.value = Object.values(relation_list.value).slice(2);
        if (!relation.value[2]) {
            subtitle.value = relation.value[0] + "&" + relation.value[1]
        } else if (relation.value[2] && !relation.value[3]) {
            subtitle.value = relation.value[0] + "&" + relation.value[1] + "&" + relation.value[2]
        } else if (relation.value[3]) {
            subtitle.value = relation.value[0] + "&" + relation.value[1] + "&" + relation.value[2] + "&" + relation.value[3]
        }
        ga.value = ga.value.filter(item => item.includes(relation.value[0]) || item.includes(relation.value[1]) || (item.includes(relation.value[2]) && relation.value[2]) || (item.includes(relation.value[3]) && relation.value[3]))
    })
        .catch(err => {
            console.log(err)
        })
}

const getData = async () => {
    try {
        const res = await useCache('galleryList', () => {
            return axios.get('/gallery/').then(res => res.data)
        })
        if (res && Array.isArray(res)) {
            ga.value = res.filter(item => {
                if (item.type !== 'file') return false;
                const suffix = item.name.slice(item.name.lastIndexOf('.')).toLowerCase();
                return suffixes.includes(suffix);
            }).map(item => { return 'http://img.helloworldend.top/gallery/' + item.name }).reverse()
        }
    } catch (error) {
        console.error('获取图片列表失败：', error)
    }
}


onMounted(() => {
    // var current_page = '#' + current_page_name
    // $(current_page).removeClass('page-tab')
    // $(current_page).addClass('page-tab-selected')
    // $('#' + current_page).addClass('page-tab-selected')
    getRelation(title)
    getData()
})

function show(prefix, content) {
    if (content) {
        if (!content.includes(prefix) && prefix != 'null') {
            return prefix + content
        } else {
            return content
        }
    }
}

function escape2Html(str) {                            //转义字符转换普通字符的方法
    var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'middot': '·' };
    return str.replace(/&(lt|gt|nbsp|amp|quot|middot);/ig, function (all, t) { return arrEntities[t]; });
}


function keyword(str, charas, articles, name) {
    str = keyword_search(str, charas, name)
    str = keyword_search(str, articles, '')
    return str
}

function keyword_search(str, keywords, name) {
    if (str) {
        for (let j = 0; j < keywords.length; j++) {
            const keyword = keywords[j]
            const i = str.indexOf(keyword)
            const str_list = str.split(keyword)
            let str_res = ''
            if (i && keyword !== name && name !== '') {
                for (let k = 0; k < str_list.length - 1; k++) {
                    str_res += str_list[k] + '<a href="/chara/' + keyword + '/profile">' + keyword + '</a>'
                }
                str_res += str_list[str_list.length - 1]
                str = str_res
            } else if (i && name == '') {
                for (let k = 0; k < str_list.length - 1; k++) {
                    str_res += str_list[k] + '<a href="/article/' + keyword + '">' + keyword + '</a>'
                }
                str_res += str_list[str_list.length - 1]
                str = str_res
            }
        }
    }
    return str
}


const handleClick = (index) => {
    showPreview.value = true
    showIndex.value = index
}

</script>
<style scoped>
.page-tab {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: skyblue;
    text-align: center;
    margin-right: 4px;
}

.page-tab a {
    color: white;
}

.page-tab:hover {
    background-color: rgba(135, 206, 235, 0.2);
}

.page-tab:hover a {
    color: skyblue;
}

.page-tab-selected {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: MediumTurquoise;
    text-align: center;
    margin-right: 4px;
}

.page-tab-selected a {
    color: white;
}

.info {
    background-color: white;
    padding: 2%;
}
</style>
